import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { checkPolotnoType } from '@/pages/AdvancedEditor/utils';
import styled from '@emotion/styled';
import { ImageDetails, VideoDetails } from './MediaDetails';
import { MediaList } from './MediaList';

const MediaPanelContainer = styled.div`
    padding: 20px 20px 0 !important;
    height: 100%;
    overflow: hidden;
    gap: 24px;
    display: flex;
    flex-direction: column;
`;

export const MediaPanel = () => {
    const { store } = useAdvancedEditorContext();

    const isVideoSelected = checkPolotnoType(store.selectedElements[0], polotnoTypes.Video);
    const isImageSelected = checkPolotnoType(store.selectedElements[0], [polotnoTypes.Image, polotnoTypes.Svg]);

    return (
        <MediaPanelContainer data-testid="media-panel">
            {isVideoSelected && <VideoDetails />}
            {isImageSelected && <ImageDetails />}
            {!isVideoSelected && !isImageSelected && <MediaList />}
        </MediaPanelContainer>
    );
};
